import { useContext } from "react";
import { DateFormatContext } from "@/shared/lib/date-format";

export const useDateFormat = () => {
  const context = useContext(DateFormatContext);
  if (!context) {
    throw new Error("useDateFormat must be used within a DateFormatProvider");
  }
  return context;
};

